import React from "react";
import styles from "./VimeoPlayer.module.scss";

// Define the prop types for the VimeoPlayer component.
export interface VimeoPlayerProps {
  url: string; // Video URL to embed in the iframe.
  loop?: boolean; // Flag to control video looping.
  autoPlay: boolean; // Flag to enable autoplay.
  controls?: boolean; // Flag to display video controls.
}

export const VimeoPlayer: React.FC<VimeoPlayerProps> = ({
  url,
  loop = false,
  autoPlay,
  controls = true,
}) => {
  // Generate the iframe src URL with parameters.
  // dnt=1 is added to prevent Vimeo from tracking user interactions for analytics purposes.
  const videoSrc = `${url}?autoplay=${autoPlay ?? false}&loop=${loop ?? false}&controls=${controls ?? false}&dnt=1`;

  return (
    <div className={styles.vimeo_container}>
      <iframe
        src={videoSrc}
        width="100%"
        height="100%"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title="Vimeo Video"
      />
    </div>
  );
};
